import parse from 'html-react-parser'
import React from 'react'
import { FormattedMessage } from 'react-intl'

const OwnerBrief = ({ briefOwner }: { briefOwner: string }) => {
  return (
    <div className='h-56 overflow-scroll'>
      <h3 className='mb-4 text-grey-700'>
        <FormattedMessage
          id='ui.OwnerBrief.title'
          defaultMessage='Brief client'
        />
      </h3>
      <div>{parse(briefOwner ?? '')}</div>
    </div>
  )
}

export default OwnerBrief
